import React from "react";
import { MessageWithAvatarAndCTA } from "../../../../../core/atoms/atoms";
import { GoogleAnalyticsHelper } from "@travellocal/ui";
import * as StringUtil from "@travellocal/utils/stringHelpers";
import * as WebRoutes from "@travellocal/utils/webRoutes";

import "./newMessage.scss";

interface NewMessageProps {
  enquiry: IEnquiry;
  message: IMessage;
  lto: ILto;
}

export const NewMessage: React.FC<NewMessageProps> = ({ enquiry, message, lto }) => {
  const { currentQuoteId } = enquiry;
  const { enquiryId, fromUser, text, messageType } = message;

  const isItinMessage = messageType === MessageType.Itinerary;
  const isLtoUser = fromUser?.userType === UserType.LtoEmployee;

  const messageWithAvatarProps = {
    avatarUrl: fromUser?.image
      ? fromUser.image.thumbnailUrl
      : "/images/anon.jpg",
    avatarName: `${fromUser?.firstName} from ${isLtoUser ? lto?.name : "TravelLocal"}`,
    ctaText: isItinMessage ? "View itinerary" : "Read message",
    ctaUrl: isItinMessage
      ? WebRoutes.customerEnquiryItinerary(enquiryId, currentQuoteId)
      : `${WebRoutes.customerEnquiryMessaging(enquiryId)}#link-from-new-message-card`,
    ctaCallback: () => GoogleAnalyticsHelper.logEvent(`View ${isItinMessage ? "itinerary" : "message"}`, "Click", "Home tab"),
    subject: `I've sent you a new ${isItinMessage ? "itinerary" : "message"}...`
  }

  return (
    <MessageWithAvatarAndCTA
      {...messageWithAvatarProps}
    >
      <div className="new-message-content" dangerouslySetInnerHTML={{ __html: StringUtil.truncate(text, 160) }}></div>
    </MessageWithAvatarAndCTA>
  );
}
